module.exports = __webpack_public_path__ + "img/alu_3.30938444.webp";